import React from "react";
//#region types
import { CreditedInvoiceBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";

//#endregion
//#region components
import { Banner, BannerField, Icon, MoreActionsButton, StyledButton } from "components/common";
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CreditedInvoiceBanner: React.FC<CreditedInvoiceBannerProps> = (props) => {
  const { invoice, displayType } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const onClicked = async (id: number) => {
    navigate(UrlHelper.formatPath(`/Invoice/${id}`), {
      state: { background: location },
    });
  };

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] =
      invoice.creditInvoiceIds?.map((id) => {
        return creditedInvoiceIdsListAction(id);
      }) ?? [];
    return actions;
  };

  const creditedInvoiceIdsListAction = (id: number): MoreActionMenuItemType => {
    return {
      description: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreditInvoice)} ${id}`,
      icon: IconDefinitionConstants.WDocument,
      onClickHandler: onClicked.bind(null, id),
    };
  };

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreditedInvoice)}
      icon={IconDefinitionConstants.WMoney}
      type={displayType}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreditedInvoiceDescription)}
        </Grid>
        <Grid item className={cssExports.creditInvoiceBanner}>
          <Grid container direction="row" spacing={3}>
            <Grid item>
              <Icon icon={IconDefinitionConstants.WCalculator} displayType={displayType} className={cssExports.icon} />
            </Grid>
            <Grid item>
              <BannerField
                label={LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Invoice.RemainingAmountAfterCredit
                )}
                value={LocalizationHelperInstance.getFormattedCurrency(
                  invoice.remainingCostAfterCredit ?? 0,
                  invoice.currency
                )}
              />
            </Grid>
            <Grid item>
              <BannerField
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.UnpaidAmountAfterCredit)}
                value={LocalizationHelperInstance.getFormattedCurrency(invoice.leftToPay ?? 0, invoice.currency)}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {invoice.creditInvoiceIds?.length === 1 ? (
            <StyledButton
              size="sm"
              displayType={displayType}
              onClick={onClicked.bind(null, invoice.creditInvoiceIds?.length ? invoice.creditInvoiceIds[0] : 0)}
            >
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ViewCreditInvoice)}
            </StyledButton>
          ) : (
            <MoreActionsButton
              onClick={onClicked.bind(
                null,
                invoice.creditInvoiceIds?.length ? invoice.creditInvoiceIds[invoice.creditInvoiceIds?.length - 1] : 0
              )}
              menuItems={getMenuItems()}
              displayType={displayType}
              alignItems="flex-start"
              size="sm"
            >
              {`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ViewCreditInvoice)} {${
                invoice.creditInvoiceIds?.length
              }}`}
            </MoreActionsButton>
          )}
        </Grid>
      </Grid>
    </Banner>
  );
};

export default CreditedInvoiceBanner;
